enum ConditionSuggestionEntityTypeEnum {
    Application = 'APPLICATION',
    Borrower = 'BORROWER',
    Property = 'PROPERTY',
}

export default ConditionSuggestionEntityTypeEnum;